import * as React from "react";
import {Component} from "react";

export class EmptyCell extends Component {
    render() {
        return (
            <td className="double-data" />
        );
    }
}
